const apyToApyList = (apy: number) => {
  const monthApy = Math.pow(1 + apy, 1 / 12) - 1;
  return [
    monthApy,
    Math.pow(1 + monthApy, 6) - 1,
    apy,
    Math.pow(1 + monthApy, 24) - 1,
  ];
};

export default apyToApyList;
